import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { selectStationAssignmentData } from '../../store/slices/stationAssignmentSlice';
import StationAssignmentTabs from '../StationAssignmentTabs';
import ShiftRosterPage from '../../pages/stationAssignment/shiftRoster';
import AssignmentsPage from '../../pages/stationAssignment/assignments';
import ReviewAndPublishPage from '../../pages/stationAssignment/reviewAndPublish';

/**
 * StationAssignmentLayout component that provides persistent tabs and nested routing
 * for the station assignment workflow. Reads date/shift from Redux store.
 * Mirrors the ShiftPlanLayout pattern.
 */
const StationAssignmentLayout: React.FC = () => {
  // Get station assignment data from Redux store
  const { selectedDate, selectedShift, isStationAssignmentActive } =
    useAppSelector(selectStationAssignmentData);

  // If no station assignment is active, redirect to the main page
  if (!isStationAssignmentActive || !selectedDate || !selectedShift) {
    return <Navigate to="/" replace />;
  }

  return (
    <StationAssignmentTabs date={selectedDate} shiftType={selectedShift}>
      <Routes>
        {/* Default route - redirect to shift-roster */}
        <Route path="/" element={<Navigate to="shift-roster" replace />} />

        {/* Tab content routes */}
        <Route path="/shift-roster" element={<ShiftRosterPage />} />
        <Route path="/assignments" element={<AssignmentsPage />} />
        <Route path="/review-and-publish" element={<ReviewAndPublishPage />} />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="shift-roster" replace />} />
      </Routes>
    </StationAssignmentTabs>
  );
};

export default StationAssignmentLayout;
